import { SettingsIdValues } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { EditSettingsPage } from "~/areas/configuration/components/Settings/EditSettingsPage";
export function OktaSettingsPage() {
    return <EditSettingsPage settingId={SettingsIdValues.Okta}/>;
}
